<div
  [formGroup]="form"
  class="flex justify-between gap-4 py-2 px-6 items-center"
>
  <mat-form-field class="input-tg mt-message-input w-5/12" appearance="outline">
    <mat-label>Descrição</mat-label>
    <input matInput formControlName="description" />
  </mat-form-field>
  <mat-form-field
    class="input-tg w-5/12 px-2 no-message-new"
    appearance="outline"
  >
    <mat-label>Valor</mat-label>
    @if (form.get('price')!.value != '') {
      <span matTextPrefix>R$&nbsp;</span>
    }
    <input matInput formControlName="price" currencyInput />
  </mat-form-field>
  <button
    mat-flat-button
    class="btn-tg w-2/12"
    [disabled]="form.invalid"
    (click)="createItem()"
  >
    @if (loading) {
      <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
    } @else {
      Adicionar Novo
    }
  </button>
  <!--  <button mat-flat-button class="btn-tg w-full mt-6" [disabled]="!checkForm()" (click)="sendLogin()">entrar</button>-->
</div>
